<template>

  <network
      class="network visContainer"
      ref="network"
      :nodes="network.nodes"
      :edges="network.edges"
      :options="network.options"
      @click="networkEvent('click')"
      @double-click="networkEvent('doubleClick')"
      @oncontext="networkEvent('oncontext')"
      @hold="networkEvent('hold')"
      @release="networkEvent('release')"
      @select="networkEvent('select')"
      @select-node="selectNode()"
      @select-edge="networkEvent('selectEdge')"
      @deselect-node="selectNode()"
      @deselect-edge="networkEvent('deselectEdge')"
      @drag-start="networkEvent('dragStart')"
      @dragging="networkEvent('dragging')"
      @drag-end="networkEvent('dragEnd')"
      @hover-node="networkEvent('hoverNode')"
      @blur-node="networkEvent('blurNode')"
      @hover-edge="networkEvent('hoverEdge')"
      @blur-edge="networkEvent('blurEdge')"
      @zoom="networkEvent('zoom')"
      @show-popup="networkEvent('showPopup')"
      @hide-popup="networkEvent('hidePopup')"
      @start-stabilizing="networkEvent('startStabilizing')"
      @stabilization-progress="networkEvent('stabilizationProgress')"
      @stabilization-iterations-done="networkEvent('stabilizationIterationsDone')"
      @stabilized="networkEvent('stabilized')"
      @resize="networkEvent('resize')"
      @init-redraw="networkEvent('initRedraw')"
      @before-drawing="networkEvent('beforeDrawing')"
      @after-drawing="networkEvent('afterDrawing')"
      @animation-finished="networkEvent('animationFinished')"
      @config-change="networkEvent('configChange')"
      @nodes-mounted="networkEvent('nodes-mounted')"
      @nodes-add="networkEvent('nodes-add')"
      @nodes-update="networkEvent('nodes-update')"
      @nodes-remove="networkEvent('nodes-remove')"
      @edges-mounted="networkEvent('edges-mounted')"
      @edges-add="networkEvent('edges-add')"
      @edges-update="networkEvent('edges-update')"
      @edges-remove="networkEvent('edges-remove')"
    />
</template>

<script>
import graphService from '../graphService/graphService.js';
import { mapState } from 'vuex'

export default {
  name: "Graph",
  methods:{
    selectNode() {
      let nodeId = this.$refs.network.getSelection().nodes[0];
      const currentSelectedNode = (nodeId != null) ? this.network.nodes.get(nodeId) : null;
      this.$store.commit('global/setSelectedNode', currentSelectedNode);
    },
    networkEvent() {
      // console.log('event: ', eventName)
    },
    saveData(data, callback) {
      data.id = document.getElementById("node-id").value;
      data.label = document.getElementById("node-label").value;
      // clearPopUp();
      callback(data);
    }
  },
  data () {
    return {
      schoolId: "e5abIXEqXZc3x5I0hYhd",
      network: graphService.getGraphByUserId(0),
      currentSelectedNode: null,
    }
  },
  computed: {
    ...mapState('global', [
      'selectedGraph'
    ])
  },
  watch: {
    selectedGraph: {
      immediate: true,
      handler (newValue, oldValue) {
        console.log("selectedGraph: newValue: ", newValue)
        console.log("selectedGraph: oldValue: ", oldValue)
        
        console.log("current network: ", this.network)


        // if(newValue !== null && newValue !== undefined) this.network.setData({ nodes: nodes, edges: []});
        //   this.network = {
        //     nodes: [],
        //     edges: [],
        //     options: {}
        //   };
        graphService.getGraphById(this.schoolId, newValue).then( newNetwork => {

          this.network = newNetwork;

          this.networkNodes = newNetwork.nodes;
          this.networkEdges = newNetwork.edges;
          this.networkOptions = newNetwork.options;

          this.$refs.network.setData(newNetwork.nodes, newNetwork.edges);
          this.$refs.network.redraw();
          this.currentSelectedNode = null;
        });
      }
    }
  },
  created() {
  },
  destroyed() {
  }
};
</script>
<style scoped>

.main {
  height: 100%;
  display: flex;
}

.visContainer {
  height: 100%;
  width: 100%;
}

.detailContainer {
  width: 35%;
  height: 100%;
  position: absolute;
  right: 0;
  opacity: 0.85;
  background: #000;
  padding: 10px;
  color: #fff;
}

.detailContents {
  color: #fff;
  margin: 10px;
}

.white {
  display: block; height: 1px;
    border: 0; border-top: 1px solid #ccc;
    margin: 1em 0; padding: 0; 
}

.materials {
  font-size: smaller
}


.progress-bar {
  width: 100%;
  background-color: #e0e0e0;
  padding: 3px;
  border-radius: 3px;
  box-shadow: inset 0 1px 3px rgba(0, 0, 0, .2);
}
			
.progress-bar-fill {
  display: block;
  height: 22px;
  background-color: #659cef;
  border-radius: 3px;
  
  transition: width 500ms ease-in-out;
}


</style>
